import {  Injectable } from '@angular/core';
import { BehaviorSubject, distinctUntilChanged, Subject } from 'rxjs';
import { operationinterface } from 'src/app/interface/OperationInterface';
import { valorlatenteinterface } from 'src/app/interface/ValorLatenteInterface';
import { rendimientoanualinterface } from 'src/app/interface/RendimientoAnualInterface';
import { tablainterface } from 'src/app/interface/TablaInterface';
import { valorliquidativointerface } from '../interface/ValorLiquidativoInterface';
import { OptimalWallet } from '../interface/OptimalWallet';

@Injectable({
    providedIn: 'root',
})

export class DiversificadorService {

    /* Behavior Subject */
    public divOperaciones = new BehaviorSubject<operationinterface[]>([]);
    private divValLatente = new BehaviorSubject<valorlatenteinterface[]>([]);
    private divValLiq = new BehaviorSubject<valorliquidativointerface[]>([]);
    private divValPos = new BehaviorSubject<operationinterface[]>([]);
    private divValVentas = new BehaviorSubject<operationinterface[]>([]);
    private divRentabilidad = new BehaviorSubject<tablainterface[]>([]);
    private divRendAnual = new BehaviorSubject<rendimientoanualinterface[]>([]);
    private divRiesgo = new BehaviorSubject<tablainterface[]>([]);
    private idcarteras = new BehaviorSubject<number[]>(Array(100).fill(0));
    private idModelos = new BehaviorSubject<number[]>(Array(100).fill(0));
    private idcarterasOptima = new BehaviorSubject<number[]>(Array(100).fill(0));
    private divFechaFiltro = new BehaviorSubject<string>('');
    executeGrap = new BehaviorSubject<boolean>(false);
    divOptimalWallet  = new BehaviorSubject<OptimalWallet>({
        apalancamiento: 1,
        bajista: false,
        capitalinicial: 100000.0,
        idcartera: 0,
        nombre: '',
        valorLiquidativo: 100000,
        valorliquidativoTemp: 0.0,
        riesgomaximo: 50.0,
        tipocuenta: 'MARGEN',
        tiporiesgo: 'LIMITADO',
        riesgo: 1000.0,
        comisionbroker: 10.0,
        idmercado: 0,
        intervalotiempo: 2,
        prima: false,
        participacion: false,
        simulado: true,
        poderCompra: 100000,
        numeroReconfiguracion: 0,
        stopLoss: 20,
        profit: 10,
        capitales:[ 1000.0, 1000.0],
        fondosDisponibles: 100000,
        margen: 0,
        margenRequeridoPor: 30,
        controlMarginCall: 75.0,
        lista: 0,
        nOperaciones: 0,
        maxDiferenciaCierres: 0.0,
        rendimientoNeto: 0.0,
        rendimientomedioanual: 0.0,
        rendimientoacumuladoanual: 0.0,
        tasacrecimientoanualcompuesto: 0.0,
        periodosoperativa: 0,
        beneficioneto: 0.0,
        beneficionetoporcentual: 0.0,
        mayorretrocesodesdemaximo: 0.0,
        mayorretrocesodesdemaximoporcentual: 0.0,
        mediabeneficioperdidaporcentual: 0.0,
        sumaresiduosbeneficioperdidaporcentual: 0.0,
        volatilidadperiodo: 0.0,
        volatilidadanual: 0.0,
        mesesdd: 0,
        maximoretrocesoperiodo: 0.0,
        sumarrendimientosanuales: 0.0,
        prombeneficiointervalo: 0.0,
        prombeneficionintervaloporcentual: 0.0,
        sumatorio: false,
        coeficientevolatilidadanual: 1.0,
        ratiobeneficioriesgo: 0.0,
        modelodesde: '',
        efectivo: 100000.0,
        gastosGestionPor: 1.0,
        gastosPrestamoPor: 8.0,
        nRecalcular: 0,
        idModelo: 0,
        liquidativos: null,
        sincro: true,auto:false,
        idCarteras: Array(100).fill(0),
        subCarteras: '',
        chkgastogest:true,
        chkgastoprest:true,
        chkcomisionbroker:true
    });
    public defaultOptima : OptimalWallet={
        apalancamiento: 1,
        bajista: false,
        capitalinicial: 100000.0,
        idcartera: 0,
        nombre: '',
        valorLiquidativo: 100000,
        valorliquidativoTemp: 0.0,
        riesgomaximo: 50.0,
        tipocuenta: 'MARGEN',
        tiporiesgo: 'LIMITADO',
        riesgo: 1000.0,
        comisionbroker: 10.0,
        idmercado: 0,
        intervalotiempo: 2,
        prima: false,
        participacion: false,
        simulado: true,
        poderCompra: 100000,
        numeroReconfiguracion: 0,
        stopLoss: 20,
        profit: 10,
        capitales:[ 1000.0, 1000.0],
        fondosDisponibles: 100000,
        margen: 0,
        margenRequeridoPor: 30,
        controlMarginCall: 75.0,
        lista: 0,
        nOperaciones: 0,
        maxDiferenciaCierres: 0.0,
        rendimientoNeto: 0.0,
        rendimientomedioanual: 0.0,
        rendimientoacumuladoanual: 0.0,
        tasacrecimientoanualcompuesto: 0.0,
        periodosoperativa: 0,
        beneficioneto: 0.0,
        beneficionetoporcentual: 0.0,
        mayorretrocesodesdemaximo: 0.0,
        mayorretrocesodesdemaximoporcentual: 0.0,
        mediabeneficioperdidaporcentual: 0.0,
        sumaresiduosbeneficioperdidaporcentual: 0.0,
        volatilidadperiodo: 0.0,
        volatilidadanual: 0.0,
        mesesdd: 0,
        maximoretrocesoperiodo: 0.0,
        sumarrendimientosanuales: 0.0,
        prombeneficiointervalo: 0.0,
        prombeneficionintervaloporcentual: 0.0,
        sumatorio: false,
        coeficientevolatilidadanual: 1.0,
        ratiobeneficioriesgo: 0.0,
        modelodesde: '',
        efectivo: 100000.0,
        gastosGestionPor: 1.0,
        gastosPrestamoPor: 8.0,
        nRecalcular: 0,
        idModelo: 0,
        liquidativos: null,
        sincro: true, auto:false,
        idCarteras: Array(100).fill(0),
        subCarteras: '',
        chkgastogest:true,
        chkgastoprest:true,
        chkcomisionbroker:true
    };
    isProc = new BehaviorSubject<boolean>(false);
    isACtual = new BehaviorSubject<boolean>(false);//divIsShow
    divIsShow = new BehaviorSubject<boolean>(true);
    isAnalisis= new BehaviorSubject<boolean>(false);
    /* Observables */
    valDivOp$ = this.divOperaciones.asObservable();
    valDivLatente$ = this.divValLatente.asObservable();
    valDivValLiq$ = this.divValLiq.asObservable();
    valDivValPos$ = this.divValPos.asObservable();
    valDivVentas$ = this.divValVentas.asObservable();
    valDivRentabilidad$= this.divRentabilidad.asObservable();
    valDivRendAnual$ = this.divRendAnual.asObservable();
    valDivRiesgo$ = this.divRiesgo.asObservable();
    valDivIdeCarteras$ = this.idcarteras.asObservable();
    valDivFechaFiltro$ = this.divFechaFiltro.asObservable();

    valDivExecuteGrap$ = this.executeGrap.asObservable().pipe(
        distinctUntilChanged()
      );
    valDivisAnalisis$ = this.isAnalisis.asObservable().pipe(
        distinctUntilChanged()
      );
    valDivOptimaWallet$ = this.divOptimalWallet.asObservable();
    valIsProc$= this.isProc.asObservable();
    valisACtual$ = this.isACtual.asObservable();

    valdivIsShow$ = this.divIsShow.asObservable().pipe(
        distinctUntilChanged()
      );

    updatedivIsShow(value: boolean): void {
        this.divIsShow.next(value);
    }

    updatedisAnalisis(value: boolean): void {
        this.isAnalisis.next(value);
    }

    updateIsProc(value: boolean): void {
        this.isProc.next(value);
    }
  
    updateIsACtual(value: boolean): void {
        this.isACtual.next(value);
    }

    updateDivOpe(newOpe: any){
        this.divOperaciones.next(newOpe);
    }

    getOptimaWalletDiv(){
        return this.divOptimalWallet;
    }
    getDefaultOptima(){
        return this.defaultOptima;
    }

    updateDivOptimaWallet(wallet: any){
        this.divOptimalWallet.next(wallet);
    }

    updateDivLate(data: any){
        this.divValLatente.next(data);
    }

    updateDivLiq(data: any){
        this.divValLiq.next(data);
    }
    updateDivPos(data: any){
        this.divValPos.next(data);
    }
    updateDivVentas(data: any){
        this.divValVentas.next(data);
    }
    updateDivRent(data: any){
        this.divRentabilidad.next(data);
    }
    updateDivRendAnual(data: any){
        this.divRendAnual.next(data);
    }
    updateDivRiesgo(data: any){
        this.divRiesgo.next(data);
    }
    updateDivIdCarteras (data: any){
        this.idcarteras.next(data);
    }
    updateDivIdModelos (data: any){
        this.idModelos.next(data);
    }
    updateDivIdCarterasOptima (data: any){
        this.idcarterasOptima.next(data);
    }
    updateDivFechaFiltro(data: any){
        this.divFechaFiltro.next(data);
    }

    updateDivExecuteGrap(data: boolean){
        this.executeGrap.next(data);
    }

}